
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import MenuItemLimitAddEdit from '@/views/DashView/MenuItemLimit/MenuItemLimitAddEdit.vue';
import { getResponseToMTHForNewPort } from '@/utils/helpers';
import constants from '@/utils/constants';

class MenuItemLimitItem {
  id: string = '';
  outletCode: string = '';
  menuItemCode: string = '';
  orderType: string = '';
}

@Component({
  components: {
    editor: MenuItemLimitAddEdit
  }
})
export default class MenuItemLimitList extends RemoteDataTable<
  MenuItemLimitItem
  > {
  public pageTitle: string = 'Menu Item Limit List';

  public newButtonText: string = 'New Menu Item';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'asset_id', label: 'Menu Item Code' }),
    new RemoteDataField({ key: 'value', label: 'Order Type' })
  ];

  // to get page data
  get items(): MenuItemLimitItem[] {
    return this.$store.getters.GetAllMenuItemLimit;
  }

  get paging(): MenuItemLimitItem[] {
    return this.$store.getters.PagingMenuItemLimit;
  }

  get sorting(): MenuItemLimitItem[] {
    return this.$store.getters.SortingMenuItemLimit;
  }

  get filtering(): MenuItemLimitItem[] {
    return this.$store.getters.FilteringMenuItemLimit;
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingMenuItemLimit', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringMenuItemLimit', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.menuItemLimit.pagingMenuItemLimit.page = 1;
    }
    this.$store.dispatch('GetAllLimitForNewInterface');
  }

  mounted() {
    if (!this.$store.state.commonUtils.isFetchingData) {
      this.reload();
    }
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteLimitForNewInterface', {
            asset_id: item.asset_id,
            value: item.value
          })
          .then(response => {
            getResponseToMTHForNewPort(
              response,
              this.$swal,
              constants.RECORD_IS_DELETED
            );
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.menuItemLimit.pagingMenuItemLimit.size = page;
    this.$store.dispatch('GetAllLimitForNewInterface');
  }
}
